import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { createFragmentContainer, graphql } from 'react-relay';

import TransactionPresenter from '../../presenters/TransactionPresenter';
import appRoutes from '../../routes/appRoutes';
import { ElementLink } from '../../components';

const TransactionCellView = (props) => {
  const {
    transaction,
    previousTransaction,
    handleCheckbox,
    cashbacksSelected,
  } = props;
  const isFirstDateFromGroup =
    TransactionPresenter.date(transaction) !==
    TransactionPresenter.date(previousTransaction);
  const history = useHistory();
  const [isSelected, setIsSelected] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const index = cashbacksSelected.findIndex(
      (item) => item.plaidTransactionId === transaction.id
    );
    if (index !== -1) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [cashbacksSelected, transaction]);

  useEffect(() => {
    setIsDisabled(
      (TransactionPresenter.cashbackId(transaction) &&
        TransactionPresenter.isActive(transaction)) ||
        (cashbacksSelected.length > 9 && !isSelected)
    );
  }, [cashbacksSelected, isSelected, transaction]);

  const handleRedirectToCashback = (e) => {
    e.stopPropagation();

    const path = appRoutes.cashbackPath(
      TransactionPresenter.cashbackId(transaction)
    );
    history.push(path);
  };

  const handleOnPress = (transaction) => {
    if (isDisabled) return;
    handleCheckbox({
      plaidTransactionId: transaction.id,
      date: transaction.date,
      ignoreMembership: false,
    });
  };

  return (
    <React.Fragment>
      {isFirstDateFromGroup && (
        <tr className="date-group-title">
          <td className="date-title" colSpan="9">
            {TransactionPresenter.date(transaction)}
          </td>
        </tr>
      )}
      <tr className="transaction-cell">
        <td
          className="checkbox-cell"
          onClick={() => handleOnPress(transaction)}
          disabled={isDisabled}
        >
          <input
            type="checkbox"
            disabled={isDisabled}
            id={`isChecked-${TransactionPresenter.id(transaction)}`}
            checked={isSelected}
            readOnly
          />
          <label htmlFor="checkbox"></label>
        </td>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.date(transaction)}
        </ElementLink>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.name(transaction)}
        </ElementLink>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.storeName(transaction)}
        </ElementLink>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.location(transaction)}
        </ElementLink>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.merchantName(transaction)}
        </ElementLink>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.amountReadable(transaction)}
        </ElementLink>
        <ElementLink
          element="td"
          to={appRoutes.transactionPath(TransactionPresenter.id(transaction))}
        >
          {TransactionPresenter.status(transaction)}
        </ElementLink>
        <td>
          {TransactionPresenter.isTransactionWithCashback(transaction) ? (
            <button
              className="nav-button"
              onClick={handleRedirectToCashback}
              role="link"
            >
              {TransactionPresenter.displayedCashbackRate(transaction)}
            </button>
          ) : (
            <span>--</span>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};

TransactionCellView.propTypes = {
  transaction: TransactionPresenter.shape().isRequired,
  previousTransaction: TransactionPresenter.shape(),
};

TransactionCellView.defaultProps = {
  previousTransaction: null,
};

export default createFragmentContainer(TransactionCellView, {
  transaction: graphql`
    fragment TransactionCell_transaction on PlaidTransaction {
      id
      name
      storeName
      date
      location
      merchantName
      amount
      state
      status
      cashbackRate
      cashbackId
    }
  `,
});
